(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["advanced-layout--hero-banner-v1"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var section = document.currentScript && document.currentScript.parentElement;
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["advanced-layout--hero-banner-v2"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var section = document.currentScript && document.currentScript.parentElement;
  })();

  } catch(e) { console.error(e); }
})();
})();
